import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

function DateTimePicker() {
  const [selectedDateTime, setSelectedDateTime] = useState(null);
  const [showResult, setShowResult] = useState(false);

  const handleDateTimeChange = (date) => {
    setSelectedDateTime(date);
  };

  const showDateTime = () => {
    setShowResult(true);
  };

  return (
    <div>
      <h1>Date and Time Picker</h1>

      <DatePicker
        selected={selectedDateTime}
        onChange={handleDateTimeChange}
        showTimeSelect
        dateFormat="Pp"
      />

      <button onClick={showDateTime}>Show Date and Time</button>

      {showResult && (
        <p>Selected Date and Time: {selectedDateTime.toString()}</p>
      )}
    </div>
  );
}

export default DateTimePicker;
